import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito mucho dinero para empezar a invertir?',
  a: 'No, puedes empezar con $20. Lo importante es el tiempo, no la cantidad inicial.'
}, {
  q: '¿Esto me ayudará si ya tengo deudas?',
  a: 'Sí, el capítulo sobre el "Impuesto a la Ignorancia" te enseña cómo salir de ellas rápido.'
}, {
  q: '¿Es para personas que viven solo en USA?',
  a: 'Está optimizado para el sistema de USA, pero los principios de psicología de gasto aplican a cualquier región.'
}, {
  q: '¿Mis padres se ofenderán si cambio mis hábitos?',
  a: 'Este manual incluye guiones para hablar con ellos con respeto y amor, pero con firmeza.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-[#0f0f0f]" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-16">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-white/10 rounded-2xl overflow-hidden bg-dark" data-id="element-18">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-19">
                <span className="text-lg font-bold text-white pr-8" data-id="element-20">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-21">
                  <ChevronDownIcon className="w-6 h-6 text-gold-400 shrink-0" data-id="element-22" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-23">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-24">
                    <div className="p-6 pt-0 text-gray-400 text-lg leading-relaxed" data-id="element-25">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}